import React from 'react';

const qtyBtn = { width: '30px', height: '30px', border: '1px solid rgba(201,168,76,0.4)', color: '#C9A84C', background: 'transparent', fontSize: '18px', lineHeight: 1, cursor: 'pointer' };

export const DeliveryMenuItem = ({ it, discPrice, qty, onChangeQty, onCustomize }) => (
  <div className="flex gap-4 p-4" style={{ background: '#141414', border: '1px solid rgba(201,168,76,0.14)' }} data-testid={`delivery-item-${it.id}`}>
    {it.image ? (
      <img src={it.image} alt={it.name.es} className="object-cover" style={{ width: '84px', height: '84px', filter: 'brightness(0.85)' }} />
    ) : (
      <div className="flex items-center justify-center flex-shrink-0" style={{ width: '84px', height: '84px', background: '#1C1C1C', border: '1px solid rgba(201,168,76,0.14)' }}><span style={{ fontSize: '22px', color: '#9A7522' }}>山</span></div>
    )}
    <div className="flex-1">
      <div className="flex justify-between items-start">
        <h3 className="font-display" style={{ fontSize: '18px', fontWeight: 700 }}>{it.name.es}</h3>
        <span className="font-bebas" style={{ fontSize: '22px', color: '#C9A84C' }}>
          {it.discount_pct > 0 ? (
            <>
              <span style={{ textDecoration: 'line-through', opacity: 0.45, fontSize: '16px', marginRight: '8px' }}>${it.price.toFixed(2)}</span>
              <span data-testid={`disc-price-${it.id}`}>${discPrice(it).toFixed(2)}</span>
            </>
          ) : `$${it.price.toFixed(2)}`}
        </span>
      </div>
      {it.discount_pct > 0 && (
        <span className="font-body uppercase" style={{ display: 'inline-block', fontSize: '9px', letterSpacing: '1.5px', color: '#F5F5F0', background: '#8C1D22', padding: '2px 8px', marginTop: '4px' }} data-testid={`disc-badge-${it.id}`}>-{it.discount_pct}%</span>
      )}
      {it.tags && it.tags.length ? (
        <div className="flex flex-wrap mt-1" style={{ gap: '6px' }} data-testid={`tags-${it.id}`}>
          {it.tags.map((t) => (
            <span key={t} className="font-body uppercase" style={{ fontSize: '9px', letterSpacing: '1.5px', color: '#C9A84C', border: '1px solid rgba(201,168,76,0.45)', padding: '2px 8px' }}>{t}</span>
          ))}
        </div>
      ) : null}
      <p className="font-body mt-1" style={{ fontSize: '12px', fontWeight: 300, color: '#C2C1B6', lineHeight: 1.5 }}>{it.description.es}</p>
      {it.modifiers && it.modifiers.length ? (
        <button onClick={() => onCustomize(it)} className="font-body uppercase mt-3" style={{ border: '1px solid #C9A84C', color: '#C9A84C', padding: '8px 16px', fontSize: '11px', letterSpacing: '1.5px', fontWeight: 600, background: 'transparent', cursor: 'pointer' }} data-testid={`customize-${it.id}`}>
          Personalizar y agregar
        </button>
      ) : (
        <div className="flex items-center gap-3 mt-3">
          <button onClick={() => onChangeQty(it, -1)} style={qtyBtn} data-testid={`minus-${it.id}`}>−</button>
          <span className="font-bebas" style={{ fontSize: '18px', minWidth: '20px', textAlign: 'center' }} data-testid={`qty-${it.id}`}>{qty}</span>
          <button onClick={() => onChangeQty(it, 1)} style={qtyBtn} data-testid={`plus-${it.id}`}>+</button>
        </div>
      )}
    </div>
  </div>
);
